import { RoleType } from "../../types/Role";
import { put } from "../../utils/axios-config";
import { ROLES } from "../../utils/constants";

export const updateRole = async (data: RoleType) => await put<RoleType, string>(ROLES, data);